module.exports = __webpack_public_path__ + "images/597bffa0a3fdeda2970542c0ebf6b601.png";